import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";

import "./sedes.css";
import Alert from "../../modal/alert";

const SEDE_URL =
  "https://institutobilinguelasnaciones.com/terapias/backend/sede.php";

class Sedes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombreSede: "",
      listaSedes: [],
      idsedeEditar: null,
      mensajealerta: false,
      tituloM: "",
      cuerpoM: "",
    };
  }

  componentDidMount() {
    this.buscarSedes();
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  buscarSedes = () => {
    const data = new FormData();
    data.append("boton", "listarSedes");
    const config = { headers: { "Content-Type": "text/html" } };
    axios.post(SEDE_URL, data, config).then((res) => {
      if (res.data.variable1 && Array.isArray(res.data.variable2)) {
        this.setState({ listaSedes: res.data.variable2 });
      } else {
        this.setState({ listaSedes: [] });
      }
    });
  };

  guardar = () => {
    const { nombreSede } = this.state;
    if (!nombreSede.trim()) {
      this.setState({
        mensajealerta: true,
        tituloM: "Sedes",
        cuerpoM: "Debe indicar el nombre de la sede.",
      });
      return;
    }
    const data = new FormData();
    data.append("sede", nombreSede.trim());
    data.append("boton", "guardarSede");
    const config = { headers: { "Content-Type": "text/html" } };
    axios.post(SEDE_URL, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          nombreSede: "",
          mensajealerta: true,
          tituloM: "Sedes",
          cuerpoM: res.data.variable2 || "Sede guardada correctamente.",
        });
        this.buscarSedes();
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Sedes",
          cuerpoM: res.data.variable2 || "Ocurrio un problema al guardar.",
        });
      }
    });
  };

  cargarParaEditar = (idsede, nombreSede) => {
    this.setState({
      idsedeEditar: idsede,
      nombreSede: nombreSede || "",
    });
  };

  modificar = () => {
    const { idsedeEditar, nombreSede } = this.state;
    if (!idsedeEditar || !nombreSede.trim()) {
      this.setState({
        mensajealerta: true,
        tituloM: "Sedes",
        cuerpoM: "Seleccione una sede y escriba el nombre.",
      });
      return;
    }
    const data = new FormData();
    data.append("idsede", String(idsedeEditar));
    data.append("sede", nombreSede.trim());
    data.append("boton", "modificarSede");
    const config = { headers: { "Content-Type": "text/html" } };
    axios.post(SEDE_URL, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          nombreSede: "",
          idsedeEditar: null,
          mensajealerta: true,
          tituloM: "Sedes",
          cuerpoM: res.data.variable2 || "Sede actualizada correctamente.",
        });
        this.buscarSedes();
      } else {
        this.setState({
          mensajealerta: true,
          tituloM: "Sedes",
          cuerpoM: res.data.variable2 || "Ocurrio un problema al actualizar.",
        });
      }
    });
  };

  render() {
    const {
      nombreSede,
      listaSedes,
      idsedeEditar,
      mensajealerta,
      tituloM,
      cuerpoM,
    } = this.state;
    const guardarDeshabilitado = idsedeEditar != null;

    return (
      <div className="principal-sedes row">
        <div className="contenedor-sedes col-12">
          <div className="titulo-sedes">
            <p>SEDES</p>
          </div>
          {mensajealerta && (
            <Alert
              tituloMensaje={tituloM}
              cuerpoMensaje={cuerpoM}
              open={mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="contenedorp-sedes row">
            <div className="contenedorcedula1x-sedes col-12">
              <label className="label-sedes">Nombre de la sede</label>
              <input
                className="form-control input-sedes"
                type="text"
                name="nombreSede"
                id="nombreSede"
                autoComplete="off"
                placeholder="Nombre de la sede"
                maxLength="150"
                onChange={this.onChange}
                value={nombreSede}
              />
            </div>
            <div className="xcontenedorcedula1x-sedes col-12">
              <button
                className="boton-sedes"
                onClick={this.guardar}
                disabled={guardarDeshabilitado}
              >
                Guardar
              </button>
              <button
                className="boton-sedes"
                onClick={this.modificar}
                disabled={!idsedeEditar}
              >
                Modificar
              </button>
              <Link to="/">
                <button className="boton-sedes">Salir</button>
              </Link>
            </div>
          </div>
          <div className="cont-listmedix-sedes row">
            <div className="listcxcx-sedes col-12">
              <table className="tablacxcx-sedes" border="1">
                <thead>
                  <tr>
                    <th className="titucxc2-sedes">ID</th>
                    <th className="titucxc2-sedes">NOMBRE DE LA SEDE</th>
                    <th className="titucxc3x-sedes">Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {listaSedes.map((item, i) => (
                    <tr
                      className={i % 2 === 0 ? "odd" : "even"}
                      key={item.variable1}
                    >
                      <td className="totalescxcx-sedes">{item.variable1}</td>
                      <td className="totalescxcx-sedes">{item.variable2}</td>
                      <td className="titucxc3x-sedes">
                        <FeatherIcon
                          icon="edit"
                          size="20"
                          stroke="#333"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.cargarParaEditar(
                              item.variable1,
                              item.variable2
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Sedes;
